export default "/images/vendor/flag-icons/flags/4x3/ki.svg?7c0f5f6b73651b4e7159d4a6ac8a1ae1";